import { Button as MUIButton } from '@mui/material';


export default function Button(props) {
    const { text, size='small', color, variant, onClick, ...rest } = props;
    return (
        <MUIButton
            variant={variant || "contained"}
            size={size || "large"}
            color={color || "primary"}
            onClick={onClick}
            {...rest}
        >
            {text}
        </MUIButton>
    )
}
